module.exports = __webpack_public_path__ + "static/media/icon-bank-light.298b0003.svg";